<template>
  <div class="breadcrumbs">
    <a :href="`/help/${url}`"
      >Artemis Ads HelpCenter<svg class="icon iconBread" aria-hidden="true">
        <use xlink:href="#icon-jiantou-you-cu"></use></svg></a>
    <a href="javascript:;">{{ lastTitle }}</a>
  </div>
</template>

<script setup>
const { url, lastTitle = 'About Artemis Ads' } = defineProps(['url', 'lastTitle'])
</script>